import { type Control, Controller, type FieldValues, type Path } from "react-hook-form";
import { FormFieldError } from "../FormFieldError";
import {
	SearchableSelectListInput,
	type SearchableSelectListInputProps,
} from "../inputs/SearchableSelectListInput";

type FormSearchableSelectListProps<
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
> = Omit<SearchableSelectListInputProps, "value" | "onChange" | "onBlur"> & {
	// biome-ignore lint/suspicious/noExplicitAny: legacy any
	control: Control<TFieldValues, any, TTransformedValues>;
	name: Path<TFieldValues>;
};

export const FormSearchableSelectList = <
	TFieldValues extends FieldValues,
	TTransformedValues = TFieldValues,
>({
	control,
	name,
	...props
}: FormSearchableSelectListProps<TFieldValues, TTransformedValues>) => (
	<Controller
		control={control}
		name={name}
		render={({ field: { ref, ...field }, fieldState: { error } }) => (
			<div className="relative flex-shrink-0">
				{error && <FormFieldError error={error} className="left-[-10px] top-[-16px]" />}
				<SearchableSelectListInput {...field} {...props} hasError={!!error} />
			</div>
		)}
	/>
);
